(function () {
  if (window.__collectionIntroBisonInit) return;
  window.__collectionIntroBisonInit = true;

  const TARGET_SELECTOR = '[data-collection-intro-read-more-target]';
  const TARGET_ID = 'collection-intro-bison-read-more-target';

  function getHeaderOffset() {
    const header = document.querySelector('.header-bison');
    if (!header) return 100;

    const topBar = header.querySelector('.top-bar');
    const nav = header.querySelector('.custom-navbar');
    let height = 0;

    if (topBar) height += topBar.getBoundingClientRect().height;
    if (nav) height += nav.getBoundingClientRect().height;

    return Math.ceil(height > 0 ? height + 16 : 100);
  }

  function findReadMoreTarget() {
    const marked = document.querySelectorAll(TARGET_SELECTOR);
    if (marked.length) return marked[marked.length - 1];

    return document.getElementById(TARGET_ID);
  }

  function scrollToReadMoreTarget() {
    const target = findReadMoreTarget();
    if (!target) return false;

    const scrollRoot = target.closest('.shopify-section') || target;
    const offset = getHeaderOffset();

    scrollRoot.style.scrollMarginTop = `${offset}px`;

    scrollRoot.scrollIntoView({
      behavior: 'smooth',
      block: 'start',
      inline: 'nearest',
    });

    if (window.history.replaceState) {
      window.history.replaceState(null, '', `#${TARGET_ID}`);
    }

    return true;
  }

  function setIntroExpanded(wrap, expanded) {
    const preview = wrap.querySelector('[data-intro-preview]');
    const full = wrap.querySelector('[data-intro-full]');
    const moreLink = preview?.querySelector('[data-intro-expand]');
    const lessLink = full?.querySelector('[data-intro-expand]');

    if (!preview || !full) return;

    wrap.classList.toggle('is-expanded', expanded);
    preview.hidden = expanded;
    full.hidden = !expanded;

    if (moreLink) {
      moreLink.setAttribute('aria-expanded', expanded ? 'true' : 'false');
    }
    if (lessLink) {
      lessLink.hidden = !expanded;
      lessLink.setAttribute('aria-expanded', expanded ? 'true' : 'false');
    }
  }

  document.addEventListener('click', (event) => {
    const expandLink = event.target.closest('[data-intro-expand]');
    if (expandLink) {
      const wrap = expandLink.closest('[data-intro-truncate]');
      if (!wrap) return;

      event.preventDefault();
      setIntroExpanded(wrap, !wrap.classList.contains('is-expanded'));
      return;
    }

    const scrollLink = event.target.closest('[data-collection-intro-read-more]');
    if (!scrollLink) return;

    event.preventDefault();
    scrollToReadMoreTarget();
  });

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Enter' && event.key !== ' ') return;

    const expandLink = event.target.closest('[data-intro-expand]');
    if (!expandLink) return;

    event.preventDefault();
    const wrap = expandLink.closest('[data-intro-truncate]');
    if (!wrap) return;

    setIntroExpanded(wrap, !wrap.classList.contains('is-expanded'));
  });
})();
